import controller from './controller';
import template from './template.html';
import './style.less';

const controllerAs = 'detailedComplianceBreakdownCtrl';
const bindings = {};

export default {
  template,
  controller,
  controllerAs,
  bindings
};



// WEBPACK FOOTER //
// ./src/app/components/users/detailedComplianceBreakdown/index.js